const paletteMorningHorizon = {
  'red': {
    '100': '#ffeaf4',
    '200': '#ffd5ea',
    '300': '#ffb2d2',
    '400': '#ff8cb2',
    '500': '#ee3939',
    '600': '#d20a0a',
    '700': '#aa0808',
    '800': '#840606',
    '900': '#5a0404'
  },
  'orange': {
    '100': '#fef7f1',
    '200': '#ffe3c7',
    '300': '#ffc890',
    '400': '#f7ab5e',
    '600': '#e9730c',
    '500': '#f58b2e',
    '700': '#b34b0f',
    '800': '#792d06',
    '900': '#421b07'
  },
  'yellow': {
    '100': '#fff8d6',
    '200': '#fff3b8',
    '300': '#ffdf72',
    '400': '#ffc933',
    '500': '#e76500',
    '600': '#c35500',
    '700': '#a93e00',
    '800': '#8d2a00',
    '900': '#6d1900'
  },
  'lime': {
    '100': '#f5fad1',
    '200': '#ecf49f',
    '300': '#d4e45f',
    '400': '#b4ce35',
    '500': '#99bb1b',
    '600': '#7ca10c',
    '700': '#617e10',
    '800': '#42590d',
    '900': '#243503'
  },
  'green': {
    '100': '#f5fae5',
    '200': '#ebf5cb',
    '300': '#bde986',
    '400': '#97dd40',
    '500': '#36a41d',
    '600': '#188918',
    '700': '#256f3a',
    '800': '#1e592f',
    '900': '#164323'
  },
  'mint': {
    '100': '#f1fdf6',
    '200': '#cffce1',
    '300': '#96efb9',
    '400': '#67dc96',
    '500': '#3abf6f',
    '600': '#2a9856',
    '700': '#107e3e',
    '800': '#15562f',
    '900': '#08361a'
  },
  'teal': {
    '100': '#dafdf5',
    '200': '#c2fcee',
    '300': '#64edd2',
    '400': '#2ce0bf',
    '500': '#049f9a',
    '600': '#07838f',
    '700': '#046c7a',
    '800': '#035663',
    '900': '#02414c'
  },
  'azure': {
    '100': '#f5faff',
    '200': '#d6eeff',
    '300': '#a0cefc',
    '400': '#6ca8e3',
    '500': '#3c8cdd',
    '600': '#0a6ed1',
    '700': '#0854a0',
    '800': '#053b70',
    '900': '#06294b'
  },
  'blue': {
    '100': '#ebf8ff',
    '200': '#d1efff',
    '300': '#a6e0ff',
    '400': '#89d1ff',
    '500': '#1b90ff',
    '600': '#0070f2',
    '700': '#0057d2',
    '800': '#0040b0',
    '900': '#002a86'
  },
  'purple': {
    '100': '#f1ecff',
    '200': '#e2d8ff',
    '300': '#d3b6ff',
    '400': '#b894ff',
    '500': '#7858ff',
    '600': '#5d36ff',
    '700': '#470ced',
    '800': '#2c13ad',
    '900': '#1c0c6e'
  },
  'magenta': {
    '100': '#fff0fa',
    '200': '#ffdcf3',
    '300': '#ffafed',
    '400': '#ff8af0',
    '500': '#f31ded',
    '600': '#cc00dc',
    '700': '#a100c2',
    '800': '#7800a4',
    '900': '#510080'
  },
  'pink': {
    '100': '#fff0f5',
    '200': '#ffdce8',
    '300': '#fecbda',
    '400': '#feacc8',
    '500': '#fa4f96',
    '600': '#df1278',
    '700': '#ba066c',
    '800': '#9b015d',
    '900': '#71014b'
  },
  'graphite': {
    '100': '#f1f6fb',
    '200': '#e2eaf1',
    '300': '#c4d3dd',
    '400': '#a6bcc9',
    '500': '#869eac',
    '600': '#647987',
    '700': '#485d70',
    '800': '#354a5f',
    '900': '#1d3044',
    '950': '#232a31'
  },
  'gray': {
    '000': '#ffffff',
    '050': '#f5f6f7',
    '100': '#f5f6f7',
    '150': '#eaecee',
    '200': '#eaecee',
    '250': '#d5dadd',
    '300': '#d5dadd',
    '350': '#a9b4be',
    '400': '#a9b4be',
    '450': '#5b738b',
    '500': '#5b738b',
    '550': '#475e75',
    '600': '#475e75',
    '650': '#354a5f',
    '700': '#354a5f',
    '750': '#223548',
    '800': '#223548',
    '850': '#1a2733',
    '900': '#1a2733',
    '999': '#000000'
  }
};

const namedColorsMorningHorizon = {
  'brand-a': paletteMorningHorizon.mint['500'],
  'brand-b': paletteMorningHorizon.blue['500'],
  'brand-c': paletteMorningHorizon.lime['500'],
  'brand-d': paletteMorningHorizon.gray['500'],
  'brand-shell': {
    'default': paletteMorningHorizon.gray['000'],
    'faint': paletteMorningHorizon.gray['100'],
    'text': paletteMorningHorizon.gray['900']
  },
  'chart-01': {
    ...paletteMorningHorizon.blue,
    'default': paletteMorningHorizon.blue['500']
  },
  'chart-02': {
    ...paletteMorningHorizon.orange,
    'default': paletteMorningHorizon.orange['500']
  },
  'chart-03': {
    ...paletteMorningHorizon.mint,
    'default': paletteMorningHorizon.mint['500']
  },
  'chart-04': {
    ...paletteMorningHorizon.magenta,
    'default': paletteMorningHorizon.magenta['500']
  },
  'chart-05': {
    ...paletteMorningHorizon.gray,
    'default': paletteMorningHorizon.gray['500']
  },
  'chart-06': {
    ...paletteMorningHorizon.purple,
    'default': paletteMorningHorizon.purple['400']
  },
  'chart-07': {
    ...paletteMorningHorizon.yellow,
    'default': paletteMorningHorizon.yellow['400']
  },
  'chart-08': {
    ...paletteMorningHorizon.pink,
    'default': paletteMorningHorizon.pink['400']
  },
  'chart-09': {
    ...paletteMorningHorizon.azure,
    'default': paletteMorningHorizon.azure['400']
  },
  'chart-10': {
    ...paletteMorningHorizon.teal,
    'default': paletteMorningHorizon.teal['400']
  },
  'background': {
    'default': paletteMorningHorizon.gray['000'],
    'faint': paletteMorningHorizon.gray['100'],
    'disabled': paletteMorningHorizon.gray['200'],
    'hover': paletteMorningHorizon.gray['200'],
    'active': paletteMorningHorizon.gray['300'],
    'active-hover': paletteMorningHorizon.gray['400']
  },
  'text': {
    'default': paletteMorningHorizon.gray['900'],
    'faint': paletteMorningHorizon.gray['500']
  },
  'border': paletteMorningHorizon.gray['300'],
  'shadow': paletteMorningHorizon.gray['999'],
  'neutral': {
    ...paletteMorningHorizon.gray,
    'default': paletteMorningHorizon.gray['500']
  },
  'success': {
    ...paletteMorningHorizon.green,
    'default': paletteMorningHorizon.green['500']
  },
  'danger': {
    ...paletteMorningHorizon.red,
    'default': paletteMorningHorizon.red['500']
  },
  'error': {
    ...paletteMorningHorizon.red,
    'default': paletteMorningHorizon.red['500'],
    'faint': paletteMorningHorizon.red['300']
  },
  'warning': {
    ...paletteMorningHorizon.yellow,
    'default': paletteMorningHorizon.yellow['500']
  },
  'info': {
    ...paletteMorningHorizon.blue,
    'default': paletteMorningHorizon.blue['600']
  },
  'primary': {
    ...paletteMorningHorizon.blue,
    'default': paletteMorningHorizon.blue['600']
  },
  'highlight': {
    ...paletteMorningHorizon.blue,
    'default': paletteMorningHorizon.blue['600']
  },
  'alert': {
    ...paletteMorningHorizon.red,
    'default': paletteMorningHorizon.red['500']
  }
};

module.exports = {
  paletteMorningHorizon,
  namedColorsMorningHorizon
};
